<template>
    <div class="must-have-exactly-one-root-element">

        <!-- Menu -->
        <menu-album
            :profil="profil"
        />

        <!-- Main -->
        <main>
            <div class="albumMainBody">

                <div class="albumPages">
                    <div class="albumPage --first"></div>
                    <div class="albumPage --second"></div>
                    <div class="albumPage --third"></div>
                    <div class="albumPage --fourth"></div>
                </div>    

                <button @click="$router.push({ name: 'profil' })" class="sideMenu__close"><span class="icon"></span></button>
                <div class="albumList__separator"></div>

                <!-- Omaľovánky -->
                <div class="albumListing__wrap">

                    <!-- 1. strana -->
                    <div class="albumList__half --first">
                        <!-- Header -->
                        <div class="albumList__heading mb-3 d-flex align-items-center justify-content-between">
                            <h2 class="mb-0">Omaľovánky <span class="icon --questionMark" @click="$bvModal.show('modalAlbumAnatomia')"></span></h2>
                        </div>

                        <!-- Omaľovánky box -->
                        <div v-if="album.omalovanky" class="albumListing__list --omalovanky">
                            <div v-if="index >= startIndex && index <= (endIndex - 4)" 
                                 v-for="(omalovanka, index) in album.omalovanky" 
                                 class="albumListing__item">

                                <!-- Image -->
                                <div class="albumListing__imageWrap">
                                    <img :src="'assets/img/album/omalovanky/' + omalovanka.album_omalovanky_img" alt="" class="img-fluid" >
                                </div>

                                <!-- Názov -->
                                <div class="albumListing__descriptionWrap">
                                    <a :href="'assets/img/album/omalovanky/' + omalovanka.album_omalovanky_pdf" class="btn --primary" target="_blank"><span class="icon --download"></span>Stiahnuť</a>
                                    <p class="albumListing__name mb-0">
                                        <span class="name">{{ omalovanka.album_omalovanky_nadpis }}</span>
                                        <span>.pdf / {{ omalovanka.album_omalovanky_size }}</span>
                                    </p>
                                </div> 
                            </div>
                        </div>
                    </div>

                    <!-- 2. strana -->
                    <div v-if="album.omalovanky" class="albumList__half --second">
                        <!-- Omaľovánky box -->
                        <div class="albumListing__list --omalovanky">
                            <div v-if="index >= (startIndex + 4) && index <= endIndex" 
                                 v-for="(omalovanka, index) in album.omalovanky" 
                                 class="albumListing__item">

                                <!-- Image -->
                                <div class="albumListing__imageWrap">
                                    <img :src="'assets/img/album/omalovanky/' + omalovanka.album_omalovanky_img" alt="" class="img-fluid" >
                                </div>

                                <!-- Názov -->
                                <div class="albumListing__descriptionWrap">
                                    <a :href="'assets/img/album/omalovanky/' + omalovanka.album_omalovanky_pdf" class="btn --primary" target="_blank"><span class="icon --download"></span>Stiahnuť</a>
                                    <p class="albumListing__name mb-0">
                                        <span class="name">{{ omalovanka.album_omalovanky_nadpis }}</span>
                                        <span>.pdf / {{ omalovanka.album_omalovanky_size }}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <!-- Paginácia -->
                <div v-if="prevPage != 0" @click="changePage(currentPage - 1)" class="albumListing__nav --prev">
                    <span class="icon --prev"></span>Predchádzajúca strana
                </div>
                <div v-if="nextPage != 0" @click="changePage(currentPage + 1)" class="albumListing__nav --next">
                    Ďalšia strana<span class="icon --next"></span>
                </div>

            </div>
        </main>

        <!-- Modal -->
        <b-modal id="modalAlbumAnatomia" hide-footer hide-header centered class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modalAlbumAnatomiaTitle" aria-hidden="true" ref="modalAlbumAnatomia">
            <!-- Close -->
            <b-button class="m-modalInfo__close" block @click="$bvModal.hide('modalAlbumAnatomia')"><span class="icon"></span></b-button>

            <!-- Content -->
            <div class="modal-body" style="padding:0">
                <div class="text-center">

                    <h2 class="text-center">Nápoveda</h2>
                    <p class="text-18">Stiahni si niektorú z týchto krásnych kravičkovských omaľovánok a vyfarbi ju žiarivými farbami. Vytlačenú na papier môžeš vymaľovávať pastelkami, fixkami, alebo farbami. Ak ju stiahneš do tabletu, môžeš ju vymaľovať vo svojej obľúbenej maľovacej appke.</p>
                    
                </div>
            </div>
            <!-- .Content -->
        </b-modal>
        <!-- .Modal -->

    </div>
</template>



<script>
    import EventService from '@/services/EventService.js'
    import HeaderObchod from '../partials/HeaderObchod.vue'
    import MenuAlbum    from '../partials/MenuAlbum.vue'
    export default {
        components: {
            HeaderObchod,
            MenuAlbum
        },
        props: [
            'profil',
            'album',
            'error'
        ],
        mounted() {
            this.toggleBodyClass('addClass', 'album')
            this.toggleBodyClass('addClass', '--omalovanky')
            if (typeof(this.profil.id) == "undefined" || this.profil.id == 0) {
                this.$emit('updateProfil')
            }

            //sessionStorage.setItem("album-omalovanky", "refresh")
            this.getAlbumData('omalovanky')
            this.checkPagination()
        },
        destroyed() {
            this.toggleBodyClass('removeClass', 'album')
            this.toggleBodyClass('removeClass', '--omalovanky')
        },
        updated() {
            if (this.updated == 0) {
                this.getAlbumData('omalovanky')
            }
        },
        data() {
            return {
                countTotal: 0,
                countOwned: 0,
                percOwned: 0,

                prevPage: 0,
                currentPage: 0,
                nextPage: 0,
                startIndex: 0,
                endIndex: 7,

                updated: 0,

                responseType: '',
                responseText: ''
            }
        },
        methods: {
            // emit
            emitUpdateProfil() {
                this.$emit('updateProfil')
            },


            // mounted + destroy
            toggleBodyClass(addRemoveClass, className) {
                const el = document.body
                if (addRemoveClass === 'addClass') {
                    el.classList.add(className)
                } else {
                    el.classList.remove(className)
                }
            },


            // mounted
            getAlbumData(typ) {
                if (typeof(this.profil.pouzivatel_id) != 'undefined' && this.profil.id != 0) {
                    this.updated = 1

                    if ( typeof(this.album.omalovanky) == 'undefined' || sessionStorage.getItem("album-omalovanky") ) {
                        EventService.getAlbumData(typ)
                            .then(response => {
                                //console.log(response.data.data)
                                sessionStorage.removeItem("album-omalovanky")

                                // progres pre splnené úspechy
                                var items = response.data.data
                                this.countOwned = 0
                                this.countTotal = items.length

                                // emit alternative
                                this.$set(this.album, 'omalovanky', items)
                                this.checkPagination()
                            })
                            .catch(error => {
                                this.responseType = 'warning'
                                this.responseText = error
                            })

                    }
                }
            },

            checkPagination() {
                if (this.countTotal > 8 || (typeof(this.album.omalovanky) != 'undefined' && this.album.omalovanky.length > 8)) {
                    this.nextPage = 1
                }
            },


            // click
            changePage(x) {
                // draw current page
                this.startIndex = 0 + (8 * x)
                this.endIndex   = this.startIndex + 7

                // set pages
                this.nextPage    = 0
                this.prevPage    = x
                this.currentPage = x
                if ( this.endIndex < (this.countTotal - 1) || (typeof(this.album.omalovanky) != 'undefined' && this.endIndex < (this.album.omalovanky.length - 1)) ) {
                    this.nextPage = 1
                }

                //console.log(x + ': ' + this.startIndex + '-' + this.endIndex)
                //console.log(this.nextPage + ': ' + this.endIndex + '>' +this.countTotal)
            },
        }
    }
</script>